import { Item } from 'components/CollabItem/Item'
import { observer } from 'mobx-react-lite'
import { ReactControlProps } from './Types'
import { ReactionPicker } from 'components/ReactionPicker/ReactionPicker'
import { IconButton } from 'components/IconButton/IconButton'
import { useDocStore } from 'stores/DocStore'
import { useToggleTrackedChangeCommentReaction } from 'hooks/queries/trackedChangeComments/useToggleTrackedChangeCommentReaction'
import ItemStyles from 'components/CollabItem/CollabItem.module.scss'

const ReactControl = observer(({ comment }: ReactControlProps) => {
  const docStore = useDocStore()
  const { mutate: toggleReaction } = useToggleTrackedChangeCommentReaction({
    articleKey: docStore.articleId,
    layerId: docStore.layerId || '',
    comment,
  })

  return (
    <Item.Control tooltipTitle="Add reaction" tooltipPlacement="bottom">
      <ReactionPicker onSelect={toggleReaction}>
        <IconButton className={ItemStyles.controlItem} size="sm" onPress={() => toggleReaction('👍')}>
          👍
        </IconButton>
      </ReactionPicker>
    </Item.Control>
  )
})

export { ReactControl }
